
<template>
  <div class="container" v-if="isReady">
    <div class="form-container" style="max-width: 720px; margin-left: 0">
      <div class="title" style="margin: 0px 0px 32px">
        <h3 v-if="!this.pageSettings.emailValidationEnabled">
          {{ $t("please_register") }}
        </h3>
        <h3 v-if="this.pageSettings.emailValidationEnabled">
          {{ $t("register") }}
        </h3>
      </div>
      <Form
        ref="registration-form"
        :model="form"
        @keyup.enter.native="register"
      >
        <div class="fields" v-for="(field, index) in fields">
          <reg-form-item
            :data="field"
            :register-form-data="form"
            :key="index"
            :on-change-handler="formChange"
          />
        </div>

        <FormItem>
          <Button
            type="primary"
            @click="register"
            v-if="!isSaving && this.pageSettings.emailValidationEnabled"
            :style="btnStyle"
            >{{ $t("register") }}</Button
          >
          <Button
            type="primary"
            @click="register"
            v-if="!isSaving && !this.pageSettings.emailValidationEnabled"
            :style="btnStyle"
            >{{ $t("join_now") }}</Button
          >
          <Button type="primary" disable v-if="isSaving" :style="btnStyle">{{
            $t("please_wait")
          }}</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import RegFormItem from './RegFormItem.vue'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'register',
  data() {
    return {
      isSaving: false,
      webcastId: this.$store.state.webcast.copy._id,
      form: {},
      isFormValid: false,
      isReady: false
    }
  },

  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy'
    }),
    ...mapGetters('reg-form', {
      fieldsInStore: 'find'
    }),
    fields() {
      return this.fieldsInStore({ query: {} }).data
    },
    btnStyle() {
      let style = null
      if (this.pageSettings.brandColor) {
        style = {
          'background-color': this.pageSettings.brandColor,
          'border-color': this.pageSettings.brandColor
        }
      }
      return style
    }
  },
  components: {
    Navbar,
    RegFormItem
  },

  methods: {
    ...mapActions('registrations', {
      initUserAction: 'initUser'
    }),
    ...mapActions('reg-form', {
      getRegFormAction: 'find'
    }),
    formChange() {
      if (this.$refs['registration-form']) {
        console.log(this.$refs['registration-form'])
        if (Object.keys(this.form).length == this.fields.length) {
          this.$refs['registration-form'].validate(valid => {
            if (valid) this.isFormValid = true
            else this.isFormValid = false
          })
        }
      } else {
        return false
      }
    },
    register() {
      let params = {
        webcastId: this.webcastId,
        info: this.form
      }

      this.fields.forEach((value, key) => {
        console.log(value.fieldType)
        if (value.fieldType == 'email') {
          params['uid'] = this.form[_.kebabCase(value.name)]
        }
        if (value.fieldType == 'name') {
          params['name'] = this.form[_.kebabCase(value.name)]
        }

        if (value.fieldType == 'name6') {
          params['name'] = this.form[_.kebabCase(value.name6)]
        }

        if (value.fieldType == 'country') {
          params['location'] = this.form[_.kebabCase(value.name)]
        }
        if (value.fieldType == 'city') {
          params['location'] = this.form[_.kebabCase(value.name)]
        }
        if (value.fieldType == 'event_password') {
          params['event_password'] = this.form[_.kebabCase(value.name)]
        }
      })

      //console.log(params);

      if (this.$refs['registration-form']) {
        this.$refs['registration-form'].validate(valid => {
          if (valid) {
            if (this.pageSettings.eventPasswordEnabled) {
              if (_.has(params, 'event_password')) {
                if (
                  this.pageSettings.eventPassword.toUpperCase() !=
                  params.event_password.toUpperCase()
                ) {
                  this.$Message.error('Wrong event password')
                  return false
                }
              } else {
                this.$Message.error('Wrong event password')
                return false
              }
            }

            this.$set(this.$data, 'isSaving', true)
            params['isAnonymous'] = false

            this.initUserAction(params)
              .then(response => {
                this.$set(this.$data, 'isSaving', false)

                if (this.pageSettings.redirectAfterRegistrationEnabled) {
                  window.location = this.pageSettings.redirectAfterRegistrationUrl
                } else if (this.pageSettings.emailValidationEnabled) {
                  this.$router.replace('/regconfirm')
                } else if (this.$store.state.stream.ids.length > 1) {
                  this.$router.push('stream-select')
                } else {
                  if (this.webcast.hasAudioRoom) {
                    this.$router.push('webinar')
                  } else {
                    this.$router.replace('live')
                  }
                }
              })
              .catch(error => {
                console.log(error)
              })
          } else {
            /*this.$Message.error($t('registration_form_error'));*/

            this.$Modal.error({
              title: this.$t('form_validation_error'),
              content: this.$t('registration_form_error'),
              okText: this.$t('okey')
            })
          }
        })
      }
    }
  },

  created() {
    this.getRegFormAction({ query: { webcastId: this.webcastId } }).then(
      response => {
        this.isReady = true
      }
    )
  }
}
</script>
